module.exports = __webpack_public_path__ + "static/media/YandexSplit.19ac0249.svg";